module.exports = __webpack_public_path__ + "img/c25.da1bf10a.png";